import { useSelector } from "react-redux";

export function useOrganization() {
  return useSelector((state) => state.organization);
}
